<div class="map-menu-item" (click)="$event.stopPropagation()">
  <div class="header header--default">
    <h3 class="p-0 border-0">Locate on the Map</h3>
  </div>
  <div class="scroll-container main-container">
    <form [formGroup]="locateOnMapForm"
          class="search-form h-100 d-flex flex-column">
      <fieldset class="d-flex flex-column mb-0">
        <label for="locate-on-map-js" class="label mb-0">Address*</label>
        <input class="form-control"
               id="locate-on-map-js"
               type="text"
               placeholder="123 Main St., City, State, Zip"
               formControlName="myControl">
      </fieldset>

    </form>
  </div>
</div>
